export const GET_INTEGRATIONS = 'getIntegrations';
export const UPDATE_INTEGRATION = 'updateIntegration';
export const GET_INTEGRATION_REFERENCES = 'getIntegrationReferences';
export const DELETE_INTEGRATION = 'deleteIntegration';
